import { Component, Input, OnInit } from "@angular/core";
import { AppConfigService } from "src/app/services/app-config.service";

interface TwitterEmbedInterface {
  embed: string;
}

interface TwitterInterface {
  items: TwitterEmbedInterface[];
  template: string;
}

@Component({
  selector: "app-twitter",
  templateUrl: "./twitter.component.html",
  styleUrls: ["./twitter.component.scss"],
})
export class TwitterComponent implements OnInit {
  columnCount: number;

  @Input() node: TwitterInterface;

  constructor(private appConfigService: AppConfigService) {}

  ngOnInit() {
    // Embed inline Twitter JS library
    this.appConfigService.executeLibrary(this.appConfigService.twitterLibrary);
    if (this.node?.template)
      this.columnCount = 12 / parseInt(this.node.template.replace("grid-", ""));
  }
}
